module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("The Da Calvi Legacy")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgement"
    }
  }, [_vm._v("Acknowledgement")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#part-one-central-italy-19391945"
    }
  }, [_vm._v("Part One: (Central Italy\n          1939–1945)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#section"
    }
  }), _c('ol', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#section"
    }
  }), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#section"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/ch006#chapter-1-ernesto"
    }
  }, [_vm._v("Chapter 1: Ernesto")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#section-1"
    }
  }), _c('ol', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#section-1"
    }
  }), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#section-1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/ch007#chapter-2-ennio-and-ernesto"
    }
  }, [_vm._v("Chapter 2: Ennio and Ernesto")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#section-2"
    }
  }), _c('ol', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#section-2"
    }
  }), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#section-2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/ch008#chapter-3-elena"
    }
  }, [_vm._v("Chapter 3: Elena")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch009#section-3"
    }
  }), _c('ol', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch009#section-3"
    }
  }), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch009#section-3"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/ch009#chapter-4-andrea"
    }
  }, [_vm._v("Chapter 4: Andrea")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch010#part-two-central-italy-present-day"
    }
  }, [_vm._v("Part Two: (Central Italy, Present\n          Day)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch011#section-4"
    }
  }), _c('ol', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch011#section-4"
    }
  }), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch011#section-4"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/ch011#chapter-5-sebastiano-luce"
    }
  }, [_vm._v("Chapter 5: Sebastiano Luce")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch012#section-5"
    }
  }), _c('ol', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch012#section-5"
    }
  }), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch012#section-5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/ch012#chapter-6-francesco"
    }
  }, [_vm._v("Chapter 6: Francesco")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch013#section-6"
    }
  }), _c('ol', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch013#section-6"
    }
  }), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch013#section-6"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/ch013#chapter-7-ennio-and-francesco"
    }
  }, [_vm._v("Chapter 7: Ennio and Francesco")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#section-7",
      "title": "Link target outside of Sample"
    }
  }), _c('ol', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#section-7",
      "title": "Link target outside of Sample"
    }
  }), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#section-7",
      "title": "Link target outside of Sample"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-8-sebastiano",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Sebastiano")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#section-8",
      "title": "Link target outside of Sample"
    }
  }), _c('ol', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#section-8",
      "title": "Link target outside of Sample"
    }
  }), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#section-8",
      "title": "Link target outside of Sample"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-9-massimo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: Massimo")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#section-9",
      "title": "Link target outside of Sample"
    }
  }), _c('ol', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#section-9",
      "title": "Link target outside of Sample"
    }
  }), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#section-9",
      "title": "Link target outside of Sample"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-10-stefano",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Stefano")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#section-10",
      "title": "Link target outside of Sample"
    }
  }), _c('ol', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#section-10",
      "title": "Link target outside of Sample"
    }
  }), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#section-10",
      "title": "Link target outside of Sample"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-11-seb",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Seb")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#part-three-west-wales-present-day",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Three: (West Wales, Present\n          Day)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#section-11",
      "title": "Link target outside of Sample"
    }
  }), _c('ol', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#section-11",
      "title": "Link target outside of Sample"
    }
  }), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#section-11",
      "title": "Link target outside of Sample"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/ch019#chapter-12-cristi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Cristi")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#section-12",
      "title": "Link target outside of Sample"
    }
  }), _c('ol', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#section-12",
      "title": "Link target outside of Sample"
    }
  }), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#section-12",
      "title": "Link target outside of Sample"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/ch020#chapter-13-david",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: David")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#section-13",
      "title": "Link target outside of Sample"
    }
  }), _c('ol', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#section-13",
      "title": "Link target outside of Sample"
    }
  }), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#section-13",
      "title": "Link target outside of Sample"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/ch021#chapter-14-gillian",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: Gillian")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#section-14",
      "title": "Link target outside of Sample"
    }
  }), _c('ol', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#section-14",
      "title": "Link target outside of Sample"
    }
  }), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#section-14",
      "title": "Link target outside of Sample"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/ch022#chapter-15-david",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: David")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#section-15",
      "title": "Link target outside of Sample"
    }
  }), _c('ol', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#section-15",
      "title": "Link target outside of Sample"
    }
  }), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#section-15",
      "title": "Link target outside of Sample"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/ch023#chapter-16-cristi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: Cristi")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#section-16",
      "title": "Link target outside of Sample"
    }
  }), _c('ol', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#section-16",
      "title": "Link target outside of Sample"
    }
  }), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#section-16",
      "title": "Link target outside of Sample"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/ch024#chapter-17-cristi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: Cristi")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#section-17",
      "title": "Link target outside of Sample"
    }
  }), _c('ol', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#section-17",
      "title": "Link target outside of Sample"
    }
  }), _c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#section-17",
      "title": "Link target outside of Sample"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/ch025#chapter-18-cristi-and-julie",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: Cristi and Julie")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#part-four-italy-present-day",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Four: (Italy, Present Day)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#section-18",
      "title": "Link target outside of Sample"
    }
  }), _c('ol', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#section-18",
      "title": "Link target outside of Sample"
    }
  }), _c('li', {
    attrs: {
      "id": "toc-li-46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#section-18",
      "title": "Link target outside of Sample"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/ch027#chapter-19-cristi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: Cristi")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#section-19",
      "title": "Link target outside of Sample"
    }
  }), _c('ol', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#section-19",
      "title": "Link target outside of Sample"
    }
  }), _c('li', {
    attrs: {
      "id": "toc-li-48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#section-19",
      "title": "Link target outside of Sample"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/ch028#chapter-20-seb",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20: Seb")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#section-20",
      "title": "Link target outside of Sample"
    }
  }), _c('ol', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#section-20",
      "title": "Link target outside of Sample"
    }
  }), _c('li', {
    attrs: {
      "id": "toc-li-50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#section-20",
      "title": "Link target outside of Sample"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/ch029#chapter-21-cristi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21: Cristi")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#section-21",
      "title": "Link target outside of Sample"
    }
  }), _c('ol', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#section-21",
      "title": "Link target outside of Sample"
    }
  }), _c('li', {
    attrs: {
      "id": "toc-li-52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#section-21",
      "title": "Link target outside of Sample"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/ch030#chapter-22-signor-luce",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22: Signor Luce")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#part-five-the-legacy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Five: The Legacy")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#section-22",
      "title": "Link target outside of Sample"
    }
  }), _c('ol', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#section-22",
      "title": "Link target outside of Sample"
    }
  }), _c('li', {
    attrs: {
      "id": "toc-li-55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#section-22",
      "title": "Link target outside of Sample"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/ch032#chapter-23-cristi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23: Cristi")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#section-23",
      "title": "Link target outside of Sample"
    }
  }), _c('ol', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#section-23",
      "title": "Link target outside of Sample"
    }
  }), _c('li', {
    attrs: {
      "id": "toc-li-57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#section-23",
      "title": "Link target outside of Sample"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/ch033#chapter-24-seb",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24: Seb")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-58"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#section-24",
      "title": "Link target outside of Sample"
    }
  }), _c('ol', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#section-24",
      "title": "Link target outside of Sample"
    }
  }), _c('li', {
    attrs: {
      "id": "toc-li-59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#section-24",
      "title": "Link target outside of Sample"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/ch034#chapter-25-cristi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25: Cristi")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-206d183d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0